import { WeekView } from "client/Components";
import {
	ReactElement,
	Ref,
	useMemo,
	useRef,
	useState
} from "react";
import { AppointmentDetails } from "./AppointmentDetails";
import { computeAppointmentStylingOptions, StylingOptions } from "./AppointmentListItem";
import { MagisterAppointment } from "client/Api/Workspace/LiveInformation/Magister/magisterLiveInformation";
import { TimeZone } from "client/DateAndTime/timezones";

export type AppointmentCardProps = {
	appointment: MagisterAppointment;
	onNavigate: () => void;
	timezone: TimeZone;
};

export const AppointmentCard = (props: AppointmentCardProps): ReactElement => {
	const {
		appointment,
		onNavigate,
		timezone
	} = props;

	const [isViewingDetails, setIsViewingDetails] = useState<boolean>(false);

	const ref: Ref<HTMLDivElement> = useRef<HTMLDivElement>(null);

	const stylingOptions = useMemo(
		(): StylingOptions => computeAppointmentStylingOptions(appointment),
		[appointment]
	);

	return (
		<>
			<WeekView.Card
				onClick={() => setIsViewingDetails(true)}
				ref={ref}
				isSelected={isViewingDetails}
				title={appointment.description}
				style={stylingOptions.style}
				icons={stylingOptions.icons}
			>
				<WeekView.Card.Row>
					<WeekView.Card.Title>
						{appointment.description}
					</WeekView.Card.Title>
				</WeekView.Card.Row>
				<WeekView.Card.Row>
					<WeekView.Card.Info>
						{appointment.location}
					</WeekView.Card.Info>
				</WeekView.Card.Row>
			</WeekView.Card>
			{isViewingDetails && ref.current && (
				<AppointmentDetails
					target={ref.current}
					onClose={() => setIsViewingDetails(false)}
					appointment={appointment}
					onNavigate={onNavigate}
					variant={stylingOptions.style}
					timezone={timezone}
				/>
			)}
		</>
	);
};
AppointmentCard.displayName = "AppointmentCard";
